import "@/App.css";
import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";

// Lazy load non-critical routes to reduce initial bundle size and improve PageSpeed
const Shop = lazy(() => import("@/pages/Shop"));
const Collections = lazy(() => import("@/pages/Collections"));
const About = lazy(() => import("@/pages/About"));
const Contact = lazy(() => import("@/pages/Contact"));
const ProductDetail = lazy(() => import("@/pages/ProductDetail"));
const Favourites = lazy(() => import("@/pages/Favourites"));
const ShippingReturns = lazy(() => import("@/pages/ShippingReturns"));

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Layout>
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/collections" element={<Collections />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/favourites" element={<Favourites />} />
              <Route path="/shipping-returns" element={<ShippingReturns />} />
            </Routes>
          </Suspense>
        </Layout>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
